// Copyright (c) Jupyter Development Team.
// Distributed under the terms of the Modified BSD License.
import { Token } from '@lumino/coreutils';
/**
 * The token for the localforage singleton.
 */
export const ILocalForage = new Token('@jupyterlite/localforge:ILocalForage');
